
import FIcon from '@/components/atoms/icons/h-icon';

export default {
  name: 'VideoPopupButton',

  components: {
    FIcon,
  },

  props: {
    label: {
      type: String,
      default: '',
    },
    block: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    xLarge: {
      type: Boolean,
      default: false,
    },
  },
};
